var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{attrs:{"fluid":""}},[_c('router-view')],1),_c('Loader',{attrs:{"visible":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }